<template>
	<div class="margin-left">
		<div class="flex header bg-white">
			<video v-if="type == 0" class="video" :src="videourl" controls></video>
			<img v-else class="hotimg" :src="imgs" >
			<div class="caption">
				<p class="title text-left">{{title}}</p>
				<p class="text-left text-df text-999 margin-top-sm">共 {{chapter.length}} 节</p>
			</div>
		</div>
		<div class="bg-white deinfo margin-top">
			<div class="flex align-center info-title">
				<p class="pointer text-theme actve">课程目录</p>
			</div>
			<div class="">
				<div v-if="type == 0" class="flex padding-lr padding-tb-sm align-center solid-bottom pointer" v-for="(item,index) in chapter" :key="index" @click="bofa(item,index)">
					<img :class="item.is_free?'audi':'lovk'" class=" margin-right-sm" :src="index == shindex?'https://wz89.lzym.top/web/static/skill/bo.png':'https://wz89.lzym.top/web/static/skill/boyi.png'">
					<div class="flex align-center">
						<div class="fu-fs28">{{item.chapter_title}}</div>
					</div>
				</div>
				<div  v-if="type == 1" class="flex padding-lr padding-tb-sm align-center solid-bottom" v-for="(item,index) in chapter" :key="index">
					<div class="flex flex-sub align-center">
						<!-- <img class="broadcast margin-right-xs" src="../../../assets/img/broadcast.png" > -->
						<img class="block-25 margin-right-xs" src="https://wz89.lzym.top/web/static/skill/doc.png" >
						<p>{{item.chapter_title}}</p>
					</div>
					<p class="cal-btn text-theme text-sm pointer" @click="download(item)"><a id="d1"></a>立即下载</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	//TODO   视频，文件查看
	import Bus from '@/store/eventBus.js'
	import axios from 'axios'
	import {getFile} from "@/assets/js/download"
	export default {
		data() {
			return {
				id:'',
				careful:'',
				chapter:[],
				content:'',
				type:1,
				title:'',
				price:'',
				pay_num:'',
				is_buy:'',
				imgs:'',
				videourl:'',
				shid:null,
				shindex:0
			};
		},
		created(){
			Bus.$on('pudid',data=>{
				console.log(data);
				this.id = data
				this.getdetail()
			})
		},
		destroyed() {
			Bus.$off('pudid')
		},
		methods: {
			bofa(item,index){
				console.log(item);
				if(!item.is_free||this.is_buy){
					this.videourl = item.resources
					this.shindex = index
				}else{
					
					this.$message('请先购买课程');
				}
			},
			getdetail(){
				this.ajax('get', '/api/course/getInfo',{
					id:this.id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						if(res.data){
							this.chapter = res.data.chapter
							this.type = res.data.type
							this.title = res.data.title
							this.price = res.data.price
							this.pay_num = res.data.pay_num
							this.is_buy = res.data.is_buy
							this.imgs = res.data.imgs[0]
							if(this.type == 0){
								if(this.shid){
									this.chapter.map((ele,index)=>{
										if(ele.id == this.shid){
											this.videourl = ele.resources
											this.shindex = index 
										}
									})
								}else{
									this.videourl = res.data.chapter[0].resources
									this.shindex = 0
								}
							}
						}
						// this.$message(res.msg);
					}else{
						this.$message(res.msg);
					}
				})
			},
			download(item){
				let arr = item.resources.split(".");
				let options = {
				  title: item.chapter_title,
				  fileType: "application/"+arr[arr.length-1]
				};
				let link = document.getElementById("d1");
				getFile(item.resources,options,link)

				// axios(item.resources,{
				// 		responseType: 'blob', //重要代码
				// 	}).then(res =>{
				// 		const url = window.URL.createObjectURL(new Blob([res.data]));
				// 		const link = document.createElement('a');
				//         link.href = url;
				//         let fileName = item.chapter_title //保存到本地的文件名称
				//         link.setAttribute('download', fileName);
				//         document.body.appendChild(link);
				//         link.click();
				// 	})
			}
		}
	}
</script>

<style scoped lang="less">
	.header{
		width: 920px;
		.hotimg{
			width: 596px;
			height: 332px;
		}
		.video{
			width: 596px;
			height: 332px;
		}
		.caption{
			padding: 30px 19px;
		}
		.title{
			font-size: 22px;
			
		}
	}
	.block-25{
		width:50px;
		height:50px;
	}
	.deinfo{
		box-shadow: 2px 3px 29px 1px rgba(201,199,199,0.3000);
		border-radius: 20px;
		min-height: 480px;
		.info-title{
			width: 920px;
			height: 69px;
			background: #F7F6F6;
			border-radius: 20px 20px 0px 0px;
			p{
				width: 120px;
				height: 69px;
				line-height: 69px;
			}
		}
		.cal-btn{
			width: 106px;
			height: 41px;
			line-height: 41px;
			background: rgba(3,169,160,0.1);
			border: 1px solid #03A9A0;
			border-radius: 21px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/purchased/detail.vue